import { defineCustomElement } from 'vue'
import { createPinia } from 'pinia'

import { configuration } from '@dpgradio/creative'
import ChartEmbed from './ChartEmbed.ce.vue'

import './fonts.css'

// When loaded on the site, we don't need to detect it from the URL
const possibleStationId = window.Site?.stationId;

(async () => {
  if (possibleStationId) {
    await configuration.retrieveConfigForStation(possibleStationId)
  } else {
    await configuration.retrieveConfigForDetectedStation()
  }

  const pinia = createPinia()

  const chartEmbed = defineCustomElement(ChartEmbed, {
    configureApp: (app) => {
      app.use(pinia)
    },
  })

  customElements.define('chart-embed', chartEmbed)
})();